module.exports = __webpack_public_path__ + "img/icon-dead-sd-card.56618690.svg";